import {PERMISSION_TYPE} from "../../Permissions";

export const SHOW_TIME_ENTRIES = {
    name: "Hide time entries",
    permissions: [PERMISSION_TYPE.CLIENT_HIDE_TIME_ENTRIES]
};

export const SHOW_ESTIMATES = {
    name: "Hide estimates",
    permissions: [PERMISSION_TYPE.CLIENT_HIDE_ESTIMATES]
};

export const SHOW_ALL_TASKS = {
    name: "Show all tasks in assigned projects",
    permissions: [PERMISSION_TYPE.CLIENT_SEE_ALL_TASKS]
};

export const CLIENT_PERMISSION_GROUPS = [
    SHOW_TIME_ENTRIES,
    SHOW_ESTIMATES,
    SHOW_ALL_TASKS
];